import axios, { AxiosError } from 'axios'
import { useState, useEffect } from 'react'

import { API_LOCALIZATIONS } from '../consts'

/**
 * Type of localization returned from Localizations API
 */
// ! This type should match the shape of a localization returned by
// ! API_LOCALIZATIONS, don't alter unless the API format changes
export interface Localization {
  id: string
  catalog_product_id: string
  country: string
  subdivision: string
  name: string | null
  description: string | null
  category_label: string | null
  lineage: string | null
  images: string[] | null
  version: number
}

interface LocalizationsState {
  localizations?: Array<Localization>
  error?: AxiosError
}

export const useLocalizations = (
  productId?: number
): {
  refetchLocalizations: () => void
  localizations?: Array<Localization>
  error?: AxiosError<any>
} => {
  const [localizationState, setLocalizationState] = useState<LocalizationsState>({})

  const fetchLocalizations = async () => {
    if (!productId) {
      setLocalizationState({})
      return
    }

    try {
      const response = await axios.get(`${API_LOCALIZATIONS}/${productId}`)

      setLocalizationState({
        localizations: response.data.data.localizations,
      })
    } catch (err) {
      const updatedState: LocalizationsState = {}
      if (axios.isAxiosError(err)) {
        updatedState['error'] = err
      }

      setLocalizationState(updatedState)
    }
  }

  useEffect(() => {
    fetchLocalizations()
  }, [productId]) // eslint-disable-line

  return { ...localizationState, refetchLocalizations: fetchLocalizations }
}
